module.exports = __webpack_public_path__ + "img/reportsAndStatistics.473a3c99.svg";